import {
  For,
  Show,
  createEffect,
  createMemo,
  createSignal,
  lazy,
  onCleanup,
} from "solid-js";

import { getIndexComponentLists } from "@/hooks/useConfig";
import { isMobile } from "@/lib/isMobile";
import {
  FooterComponents,
  getRenderedStatus,
  updateRenderedMap,
} from "@/stores/configStore";
import { CompType } from "@/types/compontent/base/baseEnum";
import { CompontentFactory } from "@/types/compontent/compontentFactory";
import { ComponentInfo } from "@/types/swagger/front";

export default function Footer(props: { currentPath: string }) {
  function RenderIndexComponent({ item }: { item: ComponentInfo }) {
    // 使用 CompontentFactory 创建组件实例
    const factory = CompontentFactory.getInstance();
    const component = factory.createComponent({
      ...item,
      type: item.type as CompType,
    });
    // 组件卸载时清理
    onCleanup(() => {
      factory.destroyComponent(component);
    });

    // 动态导入组件
    const DynamicComponent = lazy(async () => {
      try {
        return await import(
          `@/components/H5/Components/${item.type}/index.tsx`
        );
      } catch (e) {
        console.error(`动态导入组件失败: ${item.type}`, e);
        return {
          default: () => <div>Component loading failed:{item.type}</div>,
        };
      }
    });
    const placeHeight = createMemo(() => {
      return getRenderedStatus(item.key)
        ? "unset"
        : isMobile()
          ? item.height
          : item.pc_height;
    });
    if (!item.delay) {
      setTimeout(() => {
        updateRenderedMap(item.key, true);
      }, 100);
    }
    return (
      <div style={{ height: placeHeight() }}>
        <DynamicComponent {...component} />
      </div>
    );
  }

  // const [filters, setFilters] = createSignal<ComponentInfo[]>([]);

  // const allComponents = getIndexComponentLists();
  // const baseFooterComponents = [...FooterComponents];

  // createEffect(() => {
  //   // getIndexComponentLists().filter((item) =>
  //   //   FooterComponents.includes(item.type),
  //   // );

  //   const currentPath = props.currentPath;
  //   const specialPaths = ["/bonus-center", "/affiliate"];
  //   let source = baseFooterComponents;
  //   if (specialPaths.some((path) => currentPath.includes(path))) {
  //     source = source.filter((item) => !FooterComponents.includes(item));
  //   }
  //   const filteredComponents = allComponents.filter((item) =>
  //     source.includes(item.type),
  //   );
  //   setFilters(filteredComponents);
  // });

  const [isShowFooter, setIsShowFooter] = createSignal(false);

  const getShowFooterConditions = () => {
    if (
      props.currentPath.indexOf("bonus-center") !== -1 ||
      props.currentPath.indexOf("affiliate") !== -1
    ) {
      return false;
    }
    return true;
  };

  createEffect(() => {
    setIsShowFooter(getShowFooterConditions());
  });

  return (
    <Show when={isShowFooter()} fallback={<></>}>
      <For
        each={getIndexComponentLists().filter((item) =>
          FooterComponents.includes(item.type),
        )}
      >
        {(item) => (
          <div class="wrap-h5 pt-(--module-spacing)">
            <RenderIndexComponent item={item} />
          </div>
        )}
      </For>
    </Show>
  );
}
